export default async function init() {
  const scrollingTextElements = document.querySelectorAll('[data-js-module="scrolling-text"]');

  const initScrollingText = async () => {
    const { default: ScrollingText } = await import(/* webpackChunkName: "scrolling-text" */ './scrolling-text');
    scrollingTextElements.forEach((notification) => new ScrollingText(notification));
  };

  if (scrollingTextElements.length) initScrollingText();
}

init();
